// eslint-disable-next-line no-restricted-imports
import { useOperationGetTradersQuery } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { ListData, ListDataQueryFunction, ManagerData } from 'api/types/data';
import { lodash, parseFullName } from 'helpers';

export const useOperationTraders: ListDataQueryFunction<
  ManagerData,
  {
    search?: string;
  },
  ''
> = ({ pagination, filter }) => {
  const {
    loading,
    error: serverError,
    data,
  } = useOperationGetTradersQuery({
    variables: {
      limit: pagination.limit,
      page: pagination.page + 1,
      search: filter?.search?.toString() || undefined,
    },
  });

  const error = useError(serverError);

  const listData: ListData<ManagerData> | undefined = data?.traders
    ? {
        total: data?.traders.total,
        list: lodash.compact(data?.traders.list).map((record) => ({
          id: record.id,
          name: parseFullName(record),
        })),
      }
    : undefined;

  return {
    listData,
    loading,
    error,
  };
};
